import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            深度策划的专题内容，带你从不同角度看清事件全貌
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/50 via-transparent to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-xl md:text-2xl text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500">{item.subtitle}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-500 group-hover:gap-2 transition-all">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}